<template>
  <div class="home">
    <!--
    <v-container justify-center align-center max-width="1000px">
      <Card
        title="Notificações"
        class="center-card"
      >
      Olá
    </Card>
    </v-container>
    !-->
    <nav class="navigation">
      <router-link to="/apresentacoes"><BotaoLinkHome texto="Apresentações"/></router-link>
      <router-link to="/repertorio"><BotaoLinkHome texto="Repertório"/></router-link>
      <router-link to="/inventario"><BotaoLinkHome texto="Inventário"/></router-link>
    </nav>
  </div>
</template>

<script>
// @ is an alias to /src
import BotaoLinkHome from '@/components/BotaoLinkHome.vue'

export default {
  name: 'home',
  components: {
    BotaoLinkHome
  },
  created () {
    document.title = 'Acappolli Hub'
    document.head.querySelector('meta[name=description]').content = 'Acappolli Hub'
  }
}
</script>

<style scoped>
  .navigation {
    margin: 20px;
    display: flex;
    align-items: center;
    justify-items: center;
    flex-direction: column;
  }
  .navigation a {
    text-decoration: none;
    margin-bottom: 12px;
  }
</style>
